import React from 'react';
import { createRoot } from 'react-dom/client';
import './chartSetup';

import * as serviceWorker from './serviceWorker';

import { HashRouter } from 'react-router-dom';
import './assets/base.scss';
import Main from './Application/Main';
import { ThemeProvider } from './config/ThemeContext';
import { LoadingModalProvider } from './config/LoadingModalContext';

const rootElement = document.querySelector('#root');
const root = createRoot(rootElement!);

const renderApp = (Component: React.ComponentType) => {
  root.render(
    <ThemeProvider>
      <LoadingModalProvider>
        <HashRouter>
          <Component />
        </HashRouter>
      </LoadingModalProvider>
    </ThemeProvider>,
  );
};

renderApp(Main);

serviceWorker.unregister();
